import Base from './base'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'
/**
 * 小助手
 */
class Assustant extends Base {
  /**
   * @var resource 资源
   */
  resource

  /**
   * 初始化构造方法
   *
   * @param {Object} resource Socket消息
   */
  constructor(resource) {
    super()

    this.resource = resource
  }

  handle() {
	let that = this;
	window.localStorage.setItem("assistant_message", new Date().valueOf());
    store.commit('knowService/SET_MESSAGE_COUNT', 'asc');
	this.$notify({
		message: that.resource.msg_content,
		onClick: () => {
			// 保时捷小助手的跳转
			switch (that.resource.msg_type) {
				case "1":
				case "2":
					window.localStorage.setItem("c_p_assistant_audit", 2);
					window.localStorage.setItem("routerTo", "c_p_assistant_audit");
					break;
				case "4":
					window.localStorage.setItem("c_p_assistant_audit", 1);
					window.localStorage.setItem("routerTo", "c_p_assistant_audit");
					break;
				case "5":
					window.localStorage.setItem("c_p_assistant_copy", 2);
					window.localStorage.setItem("routerTo", "c_p_assistant_copy");
					break;
				case "6":
					window.localStorage.setItem("c_p_assistant_copy", 1);
					window.localStorage.setItem("routerTo", "c_p_assistant_copy");
					break;
				case "7":
					window.localStorage.setItem("c_p_assistant_recheck", 1);
					window.localStorage.setItem("routerTo", "c_p_assistant_recheck");
					break;
			}

			// 原来的跳转
			/* Vue.prototype.$api.apiPostKnowledgeMessageGetEntityById({
				id: that.resource.msg_id
			}).then(response => {
				if(response.errcode != 0 || store.getters.userType == '0') return;
				store.commit('knowService/SET_MESSAGE_COUNT', 'desc');
				switch(that.resource.msg_type) {
					case '1':
					case '2': {
						router.push({path: '/knowledge/review', query: {activeName: 'second'}});
						break;
					}
					case '3': {
						router.push({path: '/knowledge/index', query: {EditBigScreenInfo: item.qa_id}});
						break;
					}
					case '4': {
						router.push({path: '/knowledge/review', query: {activeName: 'first'}});
						break;
					}
				}
			}); */
		}
	})
  }
}

export default Assustant
